(function () {
    'use strict';

    angular.module('app')
        .controller('contactUsButtonController', contactUsButtonController);

    contactUsButtonController.$inject = ['$scope', '$rootScope'];
    function contactUsButtonController($scope, $rootScope) {
        var vm = this;
        vm.init = init;
        vm.fName = "";

        vm.contactUs = contactUs;

        function init(formName) {
            vm.fName = formName.replace(/[^a-z0-9]/gi, '-').toLowerCase();
        }

        function contactUs(event) {
            event.preventDefault();
            $rootScope.$broadcast('open-footer-form', vm.fName);
        }
    }
})();